module.exports = __webpack_public_path__ + "static/img/ic_heart_off@2x.e6419b4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_heart_off@2x.png
// module id = N18E
// module chunks = 1